// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"l","newsItemBox":"l","img-box":"m","imgBox":"m","img-mask-box":"n","imgMaskBox":"n"};